export default __webpack_public_path__ + "static/media/tutorial-body-android.791e3450.png";